import { ChevronLeft } from 'lucide-react';

interface ContactsAppProps {
  onBack: () => void;
}

export function ContactsApp({ onBack }: ContactsAppProps) {
  return (
    <div className="min-h-screen bg-bg-primary text-white">
      <div className="bg-bg-secondary border-b border-white/10 sticky top-0 z-50">
        <div className="px-4 sm:px-6">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-3">
              <button
                onClick={onBack}
                className="w-9 h-9 rounded-full hover:bg-white/5 flex items-center justify-center transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <h1 className="text-lg font-medium">Contacts</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6">
        <p className="text-white/60">Contacts application - iCloud sync enabled</p>
      </div>
    </div>
  );
}
